
/* Candylicious — suggestions par collection du dernier produit ajouté.
   Installation : assets/candy-cart-recommendations.js dans V2 - TEST. */
(() => {
  if (window.__candyCartRecosLoaded) return;
  window.__candyCartRecosLoaded = true;

  const root = window.Shopify?.routes?.root || '/';
  const excluded = new Set(['all', 'tous-les-bonbons', 'frontpage', 'best-sellers', 'bestsellers', 'nouveautes', 'promotions', 'sale']);
  const priority = ['halal', 'vegan', 'a-l-unite', 'a-lunite', 'a-la-piece', 'a-la-piece', 'acidules', 'doux', 'old-school'];
  let lastProductId = null;
  let previousCartIds = [];
  let requestNumber = 0;
  let scheduled = false;
  let lastSignature = '';

  const parseCartData = () => {
    const el = document.querySelector('#CartDrawer .candy-recos__cart-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent).items || []; } catch { return []; }
  };

  const pickCollection = (collections) => {
    const eligible = (collections || []).filter(c => c.handle && !excluded.has(c.handle));
    if (!eligible.length) return null;
    return eligible.sort((a, b) => {
      const rank = c => {
        const i = priority.indexOf(c.handle);
        return i < 0 ? 100 : i;
      };
      return rank(a) - rank(b);
    })[0];
  };

  const money = cents => (cents / 100).toLocaleString('fr-BE', {
    style: 'currency',
    currency: 'EUR'
  });

  const escapeText = value => String(value ?? '').replace(
    /[&<>"']/g,
    char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char])
  );

  async function update() {
    const container = document.querySelector('#CartDrawer [data-candy-recos]');
    if (!container) return;

    const items = parseCartData();
    const ids = items.map(i => String(i.product_id));

    if (!ids.length) {
      container.hidden = true;
      lastSignature = '';
      previousCartIds = [];
      return;
    }

    if (lastProductId && !ids.includes(String(lastProductId))) {
      lastProductId = null;
    }

    if (!lastProductId) {
      const newlyAdded = ids.find(id => !previousCartIds.includes(id));
      lastProductId = newlyAdded || ids[ids.length - 1];
    }

    previousCartIds = ids;

    const lastItem = items.find(
      i => String(i.product_id) === String(lastProductId)
    ) || items[items.length - 1];

    const collection = pickCollection(lastItem.collections);

    if (!collection) {
      container.hidden = true;
      return;
    }

    const signature = collection.handle + ':' + ids.join(',');

    if (
      signature === lastSignature &&
      !container.hidden &&
      container.querySelector('.candy-recos__item')
    ) {
      return;
    }

    lastSignature = signature;
    const token = ++requestNumber;

    try {
      const response = await fetch(
        `${root}collections/${encodeURIComponent(collection.handle)}/products.json?limit=250`,
        { credentials: 'same-origin' }
      );

      if (!response.ok) {
        throw new Error('Collection indisponible');
      }

      const data = await response.json();

      if (token !== requestNumber || !container.isConnected) return;

      const candidates = (data.products || [])
        .filter(p => !ids.includes(String(p.id)))
        .map(p => ({
          product: p,
          variant: (p.variants || []).find(v => v.available)
        }))
        .filter(p => p.variant);

      // Deux choix aléatoires sans doublons.
      for (let i = candidates.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
      }

      const choices = candidates.slice(0, 2);

      if (!choices.length) {
        container.hidden = true;
        return;
      }

      const list = container.querySelector('.candy-recos__list');
      if (!list) return;

      list.innerHTML = choices.map(({ product, variant }) => {
        const image =
          product.images?.[0]?.src ||
          product.image?.src ||
          '';

        const imageTag = image
          ? `<img class="candy-recos__image" src="${escapeText(image)}" alt="" loading="lazy">`
          : '';

        return `
          <div class="candy-recos__item">
            ${imageTag}

            <div class="candy-recos__info">
              <span>${escapeText(product.title)}</span>
              <span class="candy-recos__price">
                ${money(Math.round(Number(variant.price) * 100))}
              </span>
            </div>

            <button
              type="button"
              class="candy-recos__add"
              data-variant="${escapeText(variant.id)}"
            >
              + Ajouter
            </button>
          </div>
        `;
      }).join('');

      container.hidden = false;
    } catch (error) {
      console.warn('Candylicious : suggestions indisponibles', error);
      container.hidden = true;
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    queueMicrotask(() => {
      scheduled = false;
      update();
    });
  }

  // Repérer le dernier produit ajouté via AJAX Shopify.
  const originalFetch = window.fetch.bind(window);

  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input?.url || '';

    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && response.ok) {
      response.clone().json().then(payload => {
        const added = payload.items?.[0] || payload;

        if (added.product_id) {
          lastProductId = String(added.product_id);
        }

        lastSignature = '';
        setTimeout(scheduleUpdate, 200);
      }).catch(() => {});
    }

    return response;
  };

  // Détecter les mises à jour AJAX du tiroir Dawn.
  const observer = new MutationObserver(mutations => {
    if (
      mutations.some(m =>
        [...m.addedNodes].some(n =>
          n.nodeType === 1 &&
          (
            n.matches?.('.candy-recos__cart-data, #CartDrawer-CartItems') ||
            n.querySelector?.('.candy-recos__cart-data')
          )
        )
      )
    ) {
      lastSignature = '';
      scheduleUpdate();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Ajouter une suggestion au panier.
  document.addEventListener('click', async event => {
    const button = event.target.closest('#CartDrawer .candy-recos__add');

    if (!button || button.disabled) return;

    button.disabled = true;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(button.dataset.variant),
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      const state = await response.json();

      if (!response.ok) {
        throw new Error(state.description || 'Ajout impossible');
      }

      const drawer = document.querySelector('cart-drawer');

      if (drawer?.renderContents && state.sections?.['cart-drawer']) {
        drawer.renderContents(state);
      } else {
        window.location.href = `${root}cart`;
      }
    } catch (error) {
      button.disabled = false;
      alert(error.message || 'Impossible d’ajouter ce produit.');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, {
      once: true
    });
  } else {
    scheduleUpdate();
  }
})();
